// API resources
import apiFormQuestionnaire from '@/api/modules/form-questionnaire.js'
import user from '@/api/modules/user'

// Mutations
import { RESET_MODULE, ADD_FORM_QUESTIONNAIRE } from '@/store/mutation-types'


// Default state
const getDefaultState = () => {
  return {
    config: [],
    answers: {}
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetchEsgQuestionnaire ({ commit }) {
    return apiFormQuestionnaire.fetchFormQuestionnaire('esg')
      .then(data => {
        commit(ADD_FORM_QUESTIONNAIRE, data.form)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  saveAnswersEsg ({ commit }, payload) {
    return user.updateEadvisory(payload)
      .then(data => {
        return data
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_FORM_QUESTIONNAIRE] (state, data) {
    state.config = data
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
